import React from "react";
import {globalPageStyle} from "../../../global/style/globalPageStyle";
import MyNormalText from "../../commons/myNormalText";

function LocemTermsOfService() {
    return (
        <div style={globalPageStyle.pageBackground}>
            <main style={globalPageStyle.main}>
                <div style={globalPageStyle.mainSectionLegal}>
                    <MyNormalText
                        text={"PIATTAFORMA “LoceM”"}
                        bold={true}
                        fontSize={30}
                    />
                    <br/>
                    <br/>
                    <MyNormalText
                        text={"TERMINI D’USO PER L’UTENTE COMMERCIALE E L’UTILIZZATORE FINALE"}
                        bold={true}
                        fontSize={30}
                    />
                    <br/>
                    <br/>
                    <MyNormalText
                        text={"Versione in vigore a partire da 27/02/2026"}
                        fontSize={24}
                    />
                </div>

                {/* Sezione 1 - già approvata */}
                <div style={globalPageStyle.mainSectionLegal}>
                    <MyNormalText text={"1. DESCRIZIONE"} bold={true} fontSize={24}/>
                    <br/>
                    <br/>
                    <MyNormalText
                        text={
                            "LoceM Solutions S.r.l.s. (di seguito, il Fornitore) è una società che si occupa dello sviluppo, della produzione e della commercializzazione di prodotti e servizi innovativi ad alto valore tecnologico, con particolare riferimento alla digitalizzazione e automazione di processi di prenotazione e noleggio di beni e servizi.\n\n" +
                            "Nell’ambito della propria attività d’impresa il Fornitore ha ideato una piattaforma, denominata “LoceM” (di seguito la “Piattaforma”) per la gestione on-line di servizi relativi al noleggio (attualmente solo) B2C (Vetrina Digitale, prenotazione e pagamento, ecc.) di mezzi e attrezzature relativi ad attività del tempo libero, con lo scopo di valorizzare il patrimonio culturale e paesaggistico del territorio.\n\n" +
                            "La Piattaforma si pone, in particolare, quale marketplace digitale, rivolto sia alle imprese che erogano i servizi di noleggio (di seguito gli Utenti Commerciali), che ai soggetti privati (per ora consumatori, di seguito, gli Utenti Privati), con il proposito di agevolare la stipulazione a distanza del contratto di noleggio tra Utenti Commerciali/Utenti Privati e la gestione delle attività prodromiche alla stipulazione e funzionali all’esecuzione del contratto di noleggio medesimo.\n\n" +
                            "La Piattaforma è accessibile dagli Utenti Commerciali, mediante apposito dashboard sul presente portale web https://locemsolutions.com/ (di seguito il Sito Web) e mediante l’applicazione LoceM App, compatibile con sistemi Android e IOS. Per gli Utenti Commerciali la Piattaforma costituisce un duttile strumento di organizzazione della Vetrina Digitale e processamento degli ordini/pagamenti/rimborsi;\n\n" +
                            "La Piattaforma è accessibile dagli Utenti Privati mediante la LoceM App, compatibile con sistemi Android e IOS. Attraverso LoceM App gli Utenti Privati avranno la possibilità di visitare le vetrine digitali degli Utenti Commerciali iscritti alla Piattaforma, selezionare gli articoli di interesse, e procedere alle operazioni di trasmissione dell’ordine di noleggio e pagamento del corrispettivo, nonché alla gestione successiva dell’ordine (annullamento, rimborso, ecc.).\n\n" +
                            "I rapporti tra Fornitore e Utente Commerciale sono regolati, oltre che dai presenti Termini d’Uso della Piattaforma, da apposito “Contratto di adesione alla Piattaforma” e dai relativi allegati (di seguito, il Contratto), che si intendono qui integralmente richiamati."
                        }
                    />
                </div>

                {/* Sezione 2 - già approvata */}
                <div style={globalPageStyle.mainSectionLegal}>
                    <MyNormalText text={"2. DEFINIZIONI"} bold={true} fontSize={24}/>
                    <br/>
                    <br/>
                    <MyNormalText
                        text={
                            "● Fornitore: indica LoceM Solutions S.r.l.s., con sede in Via Roma n. 56, 37063 – Isola della Scala (VR) – Italia, Cod. Fiscale, partita iva e n. Iscrizione registro imprese: 04967430234.\n\n" +
                            "● Piattaforma: indica il marketplace digitale LoceM, ideato e sviluppato dal Fornitore per la gestione on-line di servizi relativi al noleggio di mezzi e attrezzature relativi ad attività del tempo libero, con lo scopo di valorizzare il patrimonio culturale e paesaggistico del territorio.\n\n" +
                            "● Utente Commerciale: indica un’impresa di noleggio di mezzi e attrezzature affiliata alla Piattaforma.\n\n" +
                            "● Utilizzatore finale: indica il soggetto consumatore che intende prendere a noleggio i mezzi e le attrezzature rese disponibili dagli Utenti Commerciali all’interno della Piattaforma.\n\n" +
                            "● Contratto: indica il contratto di adesione al marketplace stipulato tra Utente Commerciale e Fornitore.\n\n" +
                            "● Account Business: indica il profilo utente dell’Utente Commerciale, attivato mediante l’iscrizione alla Piattaforma.\n\n" +
                            "● Posta: indica il sistema di messaggistica integrato di cui è dotata la Piattaforma, volto a favorire la comunicazione tra Utente Commerciale e Utilizzatore finale, in relazione ad un determinato ordine di noleggio confermato.\n\n" +
                            "● Codice del Consumo: indica il Decreto Legislativo 6 settembre 2005 n. 206.\n\n" +
                            "● Ordine di Noleggio: indica l’ordine di noleggio inoltrato dall’Utilizzatore finale mediante l’applicazione LoceM App. L’Ordine di Noleggio costituisce una proposta contrattuale formulata dall’Utilizzatore finale all’Utente Commerciale.\n\n" +
                            "● Conferma d’Ordine: indica la conferma dell’Ordine di Noleggio da parte dell’Utente Commerciale. La Conferma equivale all’accettazione della proposta contrattuale.\n\n" +
                            "● Rifiuto Ordine: indica un rifiuto dell’Ordine di Noleggio da parte dell’Utente Commerciale.\n\n" +
                            "● Payment Gateway: indica il sistema di pagamento on-line adottato dalla Piattaforma per la gestione dei pagamenti relativi agli Ordini di Noleggio confermati.\n\n" +
                            "● Sito Web: indica il sito internet di proprietà del Fornitore, raggiungibile all’indirizzo https://locemsolutions.com/\n\n" +
                            "● LoceM App: indica l’applicazione, ideata e sviluppata da LoceM, per l’accesso alla Piattaforma e l’utilizzo dei relativi servizi da parte dell’Utilizzatore finale.\n\n" +
                            "● LoceM Business App: indica l’applicazione, ideata e sviluppata da LoceM, per l’accesso alla Piattaforma e l’utilizzo dei relativi servizi da parte dell’Utilizzatore finale.\n\n" +
                            "● Dashboard: indica il pannello di controllo presente sul Sito Web, tramite il quale l’Utente Commerciale può accedere alla Piattaforma e utilizzare i relativi servizi."
                        }
                    />
                </div>

                {/* Capitolo 3 completo */}
                <div style={globalPageStyle.mainSectionLegal}>
                    <MyNormalText
                        text={"3. REGOLE FUNZIONAMENTO PIATTAFORMA"}
                        bold={true}
                        fontSize={24}
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"3.1. Iscrizione – Attivazione Account Business"}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "L’adesione alla Piattaforma da parte dell’Utente Commerciale comporterà l’attivazione di un Account Business, tramite il quale l’Utente Commerciale potrà fruire dei servizi digitali della Piattaforma.\n\n" +
                            "L’attivazione dell’Account Business avviene mediante iscrizione alla Piattaforma.\n\n" +
                            "L’iscrizione dell’Utente Commerciale è effettuata a cura del Fornitore, sulla base dei dati e delle informazioni indicate dall’Utente Commerciale.\n\n" +
                            "Al termine della procedura di attivazione l’Utente Commerciale riceverà una notifica all’indirizzo e-mail indicato dall’Utente Commerciale, con il riepilogo dei dati di inserimento, unitamente al nome utente prescelto e una password provvisoria (Credenziali d’Accesso).\n\n" +
                            "La Piattaforma sarà accessibile per l’Utente Commerciale dal Sito Web, mediante l’inserimento delle Credenziali d’Accesso.\n\n" +
                            "A seguito del primo accesso alla Piattaforma l’Utente Commerciale sarà invitato a modificare la password provvisoria."
                        }
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"3.2. Servizi erogati dalla Piattaforma"}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "Attraverso il proprio Account Business ciascun Utente Commerciale ha a disposizione:\n\n" +
                            "a) Uno spazio cloud per allestimento della Vetrina Digitale dell’Utente Commerciale;\n\n" +
                            "b) Un archivio per la ricezione degli ordini di noleggio che saranno inviati dagli Utenti Privati per il tramite della LoceM App;\n\n" +
                            "c) Un repository “Storico” con la cronologia degli ordini e delle relative conferme, rifiuti e cancellazioni d’ordine;\n\n" +
                            "d) Un servizio integrato per la notifica (e-mail e in-app) agli Utenti Commerciali (per conto degli Utenti Privati) o agli Utenti Privati (per conto degli Utenti Commerciali) di eventi correlati all’ordine di noleggio (trasmissione/ricezione ordine, trasmissione/ricezione accettazione ordine, ecc.);\n\n" +
                            "e) Un servizio integrato di messaggistica (“Posta”), attivabile a discrezione dell’Utente Commerciale, per favorire la comunicazione tra Utenti Commerciali e Utenti Privati in relazione ad uno specifico ordine di noleggio, una volta confermato;\n\n" +
                            "f) L’indicizzazione all’interno del network della Piattaforma, con attivazione di appositi tools di interazione con app di terze parti per la navigazione GPS verso i punti noleggio dell’Utente Commerciale.\n\n" +
                            "g) La possibilità di utilizzo di buoni sconto fruibili dall’Utilizzatore finale tramite app, con incidenza e importi applicati variabili a seconda degli accordi intrapresi tra Fornitore e Utente Commerciale."
                        }
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"3.3. Disattivazione Account Business e Cancellazione."}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "Ferme restando le ipotesi di limitazione, sospensione e cessazione del servizio di cui al successivo punto 5, l’Account Business sarà definitivamente disattivato decorsi 90 giorni dalla data di scioglimento, per qualsiasi causa, del Contratto (i.e. decorrenza del Termine Finale, recesso unilaterale dell’Utente Commerciale, cessazione del servizio da parte del Fornitore, risoluzione per inadempimento, ecc.).\n\n" +
                            "Decorso il suddetto termine, saranno disattivate le Credenziali d’Accesso alla Piattaforma e revocata la licenza d’uso della LoceM Business App di cui al successivo punto 4.2.\n\n" +
                            "Una volta disattivato l’Account Business, i dati e le informazioni ivi archiviate saranno definitivamente eliminate, fatta eccezione per quei dati e quelle informazioni che il Fornitore è tenuto a conservare per legge."
                        }
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"3.4. Vetrina Digitale"}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "L’allestimento della Vetrina Digitale è effettuato dal Fornitore, sulla scorta delle informazioni e della documentazione fornita dall’Utente Commerciale.\n\n" +
                            "Le informazioni richieste all’Utente Commerciale sono, in particolare:\n" +
                            "- Indicazione della tipologia di ogni prodotto offerto in noleggio;\n" +
                            "- Corrispettivo orario/giornaliero di ciascun prodotto;\n" +
                            "- Richiesta di cauzione al momento del ritiro e, in caso affermativo, il riferimento alla disciplina delle condizioni generali applicate dall’Utente Commerciale;\n" +
                            "- Indicazione termini per annullamento gratuito (in conformità con la normativa di recesso del Codice del Consumo);\n" +
                            "- Penali per annullamento ordine oltre i termini;\n" +
                            "- Ulteriori informazioni richieste ex artt. 49 d.lgs. 206/2005 (Codice del Consumo).\n\n" +
                            "La documentazione richiesta all’Utente Commerciale consiste, in particolare, in:\n" +
                            "- Immagine vetrina Utente Commerciale (formato .jpeg);\n" +
                            "- Immagini rappresentative di ciascun prodotto offerto in noleggio (formato .jpeg);\n" +
                            "- Condizioni generali di contratto applicate dall’Utente Commerciale (formato .pdf).\n\n" +
                            "L’Utente Commerciale si assume ogni responsabilità in relazione alle informazioni e alla documentazione fornita al Fornitore per la pubblicazione nella Vetrina Digitale.\n\n" +
                            "In caso di informazioni e/o documentazione manifestamente mendace, illecita, contraria a ordine pubblico o buon costume, il Fornitore può legittimamente rifiutare il caricamento nella Vetrina Digitale.\n\n" +
                            "In caso di successivo riscontro, anche per mezzo di segnalazioni da parte di Utenti Privati, di informazioni e/o documentazione mendace, illecita, contraria a ordine pubblico o buon costume, trova applicazione il successivo punto 5 (limitazione, sospensione e cessazione servizi)."
                        }
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"3.5. Contratto di noleggio."}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "Il contratto di noleggio tra Utente Commerciale e Utilizzatore finale viene stipulato a distanza mediante scambio di proposta (Ordine di Noleggio) e accettazione (Conferma Ordine).\n\n" +
                            "Il Fornitore non è parte del suddetto contratto di noleggio, né può ritenersi in alcun modo vincolato agli obblighi del contratto medesimo, se non entro i limiti degli impegni assunti con i presenti Termini d’Uso e con il Contratto.\n\n" +
                            "Il Fornitore non è agente dell’Utente Commerciale, né è soggetto ad alcun vincolo di subordinazione o esclusiva, nei confronti dell’Utente Commerciale, né detiene alcun potere di contrattazione per conto dell’Utente Commerciale o, più in generale, di rappresentanza, con la sola eccezione del mandato di cui ai successivi artt. 3.9 e 3.10 in tema di gestione di pagamenti e rimborsi, e nei limiti delle disposizioni medesime."
                        }
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"3.6. Ordine di Noleggio"}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "Ogni prodotto presente sulla Vetrina Digitale è prenotabile da parte dell’Utilizzatore finale attraverso la LoceM App.\n\n" +
                            "Ciascun Utilizzatore finale ha la possibilità di selezionare il prodotto di proprio interesse, se risulta disponibile per le date di ritiro / riconsegna prescelte dagli Utenti Privati nell’apposita sezione presente nella LoceM App.\n\n" +
                            "Al termine della procedura d’ordine l’Utilizzatore finale è indirizzato ad una pagina di riepilogo, nella quale sono indicati i dati essenziali della prenotazione prescelta, conformemente a quanto previsto all’art. 49 del Codice del Consumo, nonché il link alla pagina delle condizioni generali di contratto applicate dall’Utente Commerciale e dal Fornitore.\n\n" +
                            "Tra i dati essenziali della prenotazione prescelta sono, in particolare, indicati:\n" +
                            "- generalità e indirizzo dell’Utente Commerciale;\n" +
                            "- tipologia del prodotto;\n" +
                            "- prezzo complessivo;\n" +
                            "- data ritiro / riconsegna;\n" +
                            "- eventuale richiesta di cauzione al momento del ritiro;\n" +
                            "- politica di annullamento ordini applicata (indicazione dei termini per annullamento gratuito; penali per annullamento ordine oltre i termini).\n\n" +
                            "Completato il suddetto iter l’Utilizzatore finale può inviare l’ordine “con obbligo di pagamento” mediante apposito pulsante all’interno della LoceM App.\n\n" +
                            "L’invio dell’ordine comporta l’attivazione del procedimento tecnico di gestione del pagamento integrale del corrispettivo previsto per il noleggio, secondo le modalità di cui al successivo punto 3.9.\n\n" +
                            "Una volta effettuato l’invio dell’Ordine di Noleggio, il sistema informatico della Piattaforma procede alla verifica della sussistenza della provvista, attraverso il payment gateway di cui al successivo punto 3.9, relativamente al metodo di pagamento prescelto dall’Utilizzatore finale.\n\n" +
                            "In difetto di provvista, l’ordine non sarà preso in carico dal sistema e l’Utilizzatore finale sarà immediatamente avvisato della mancata transazione mediante messaggio pop-up all’interno della LoceM App.\n\n" +
                            "In caso di esito positivo del controllo di provvista, il sistema informatico della Piattaforma effettua le seguenti operazioni in via contestuale:\n" +
                            "a) invio comunicazione all’Utilizzatore finale (a mezzo e-mail), con il riepilogo dell’ordine inviato e le condizioni generali applicate dall’Utente Commerciale;\n" +
                            "b) registrazione dell’Ordine di Noleggio nel repository “Ordini” della LoceM App;\n" +
                            "c) invio avviso ricezione ordine all’Utente Commerciale (a mezzo e-mail);\n" +
                            "d) registrazione dell’Ordine di Noleggio nell’apposito repository dell’Account Business."
                        }
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"3.7. Conferma d’Ordine"}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "Gli Ordini di Noleggio possono essere confermati dall’Utente Commerciale entro 24 ore dalla notifica dell’avviso di ricezione ordine.\n\n" +
                            "Nell’ipotesi di ordini che prevedano l’inizio del noleggio per un periodo inferiore alle successive 24 ore, non è assicurata la conferma da parte dell’Utente Commerciale.\n\n" +
                            "Con riferimento a ciascun Ordine di Noleggio ricevuto l’Utente Commerciale può all’interno del repository selezionare, mediante appositi pulsanti, se confermare (Conferma d’Ordine) o rifiutare (Rifiuto Ordine) l’Ordine di Noleggio.\n\n" +
                            "In caso di Conferma d’Ordine il sistema informatico della Piattaforma effettua le seguenti operazioni in via contestuale:\n" +
                            "a) invio comunicazione all’Utilizzatore finale (a mezzo e-mail), con la Conferma d’Ordine;\n" +
                            "b) registrazione della Conferma d’Ordine nel repository “Ordini” della LoceM App e avviso mediante notifica in-app;\n" +
                            "c) invio comunicazione all’Utente Commerciale (a mezzo e-mail), con la Conferma d’Ordine;\n" +
                            "d) archiviazione dell’ordine confermato nel repository “Storico” dell’Account Business;\n" +
                            "e) indicazione del prodotto prenotato come “non disponibile” nella Vetrina Digitale per il periodo interessato dall’ordine confermato;\n" +
                            "f) pagamento integrale del corrispettivo, secondo le modalità previste al successivo punto 3.9.\n\n" +
                            "Nella Conferma d’Ordine sono indicate le seguenti informazioni:\n" +
                            "- avviso che l’Ordine di Noleggio è stato accettato;\n" +
                            "- generalità, indirizzo e contatti dell’Utente Commerciale;\n" +
                            "- tipologia del prodotto;\n" +
                            "- prezzo complessivo;\n" +
                            "- data ritiro / riconsegna;\n" +
                            "- eventuale richiesta di cauzione al momento del ritiro;\n" +
                            "- politica di annullamento ordini applicata (indicazione dei termini per annullamento gratuito; penali per annullamento ordine oltre i termini);\n" +
                            "- eventuali ulteriori informazioni di cui all’art. 49 Codice del Consumo;\n" +
                            "- condizioni generali applicate dall’Utente Commerciale.\n\n" +
                            "Una volta eseguite le operazioni di cui alle precedenti lettere a) – d), il contratto di noleggio tra Utente Commerciale e Utilizzatore finale deve intendersi perfezionato.\n\n" +
                            "In caso di rifiuto dell’Ordine di Noleggio, oppure di mancata accettazione entro il termine di 24 ore dalla ricezione dell’Ordine di Noleggio, l’Ordine di Noleggio deve intendersi privo di efficacia.\n\n" +
                            "In caso di Rifiuto Ordine il sistema informatico della Piattaforma effettua le seguenti operazioni in via contestuale:\n" +
                            "a) invio dell’avviso Rifiuto Ordine all’Utilizzatore finale (a mezzo e-mail);\n" +
                            "b) registrazione del Rifiuto Ordine all’interno del repository “Ordini” della LoceM App e avviso mediante notifica in-app;\n" +
                            "c) invio comunicazione all’Utente Commerciale (a mezzo e-mail), del Rifiuto Ordine;\n" +
                            "d) registrazione dell’ordine rifiutato nei termini nel repository “Storico” dell’Account Business.\n\n" +
                            "In caso di mancata conferma dell’Ordine di Noleggio da parte dell’Utente Commerciale, entro 24 ore dalla notifica di ricezione, all’Utente Commerciale sarà disabilitata la funzionalità di conferma dell’Ordine all’interno della LoceM Business App e del Sito Web."
                        }
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"3.8. Annullamento ordine"}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "Prima della Conferma d’Ordine, l’Utilizzatore finale ha sempre la possibilità di annullare gratuitamente l’Ordine di Noleggio, selezionando l’apposito pulsante all’interno del repository “Ordini” della LoceM App.\n\n" +
                            "Successivamente alla Conferma d’Ordine, l’annullamento dell’Ordine di Noleggio è possibile in conformità alla politica di annullamento applicata da ciascun Utente Commerciale.\n\n" +
                            "In base alla politica applicata dal singolo Utente Commerciale l’annullamento può essere gratuito, oppure prevedere il pagamento di una penale, anche in relazione alle tempistiche entro cui viene richiesto.\n\n" +
                            "Resta escluso il diritto di recesso anche in caso di utilizzo parziale.\n\n" +
                            "ATTENZIONE: ai sensi dell’art. 59, comma 1, lett. n) del Codice del Consumo Italiano, il diritto di recesso gratuito previsto dall’art. 52 del Codice del Consumo Italiano per i contratti stipulati a distanza dal consumatore NON è applicabile ai servizi riguardanti le attività del tempo libero, qualora il contratto preveda una data o un periodo di esecuzione specifici.\n\n" +
                            "Considerata la tipologia di servizi offerti dalla Piattaforma, è dunque possibile che il contratto di noleggio stipulato dall’Utilizzatore finale rientri nel regime di esenzione al diritto di recesso.\n\n" +
                            "Ciascun Utente Commerciale applica la propria politica di annullamento degli ordini confermati, in conformità e nel pieno rispetto dei diritti riservati al consumatore dalla normativa del Codice del Consumo Italiano, anche in riferimento al diritto di recesso sopra indicato.\n\n" +
                            "La politica di annullamento adottata da ciascun Utente Commerciale è indicata nella pagina di riepilogo dell’ordine e nelle comunicazioni di riepilogo dell’ordine e di Conferma d’Ordine.\n\n" +
                            "L’Utilizzatore finale può procedere all’annullamento mediante l’apposito pulsante nel repository “Ordini” della LoceM App.\n\n" +
                            "In caso di annullamento da parte dell’Utilizzatore finale, il sistema informatico della Piattaforma effettua le seguenti operazioni in via contestuale:\n" +
                            "a) invio della conferma dell’annullamento dell’ordine all’Utilizzatore finale (a mezzo e-mail);\n" +
                            "b) registrazione dell’annullamento dell’ordine all’interno del repository “Ordini” della LoceM App;\n" +
                            "c) invio comunicazione all’Utente Commerciale (a mezzo e-mail), dell’annullamento dell’ordine;\n" +
                            "d) registrazione dell’annullamento nel repository “Storico” dell’Account Business.\n\n" +
                            "L’annullamento dell’ordine comporta il rimborso del pagamento effettuato dall’Utilizzatore finale, al netto dell’eventuale penale applicata dall’Utente Commerciale, secondo le modalità di cui al successivo punto 3.10 (Gestione dei Rimborsi)."
                        }
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"3.9. Gestione dei pagamenti"}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "Le operazioni di pagamento sono interamente gestite, in forza di mandato conferito dall’Utente Commerciale al Fornitore con il Contratto, mediante apposito tool all’interno della Piattaforma, integrato con il payment gateway di terze parti a ciò abilitate (attualmente Stripe.com, https://stripe.com/it-us/legal/consumer).\n\n" +
                            "Il procedimento è così articolato:\n" +
                            "a) all’interno della procedura d’ordine di noleggio l’Utilizzatore finale deve inserire i dati relativi al metodo di pagamento prescelto;\n" +
                            "b) al termine della procedura l’Utilizzatore finale viene indirizzato alla pagina di riepilogo di cui al precedente punto 3.6, con la richiesta di procedere all’invio dell’ordine “con obbligo di pagamento”;\n" +
                            "c) una volta inviato l’ordine, il sistema informatico della Piattaforma provvederà a pre-autorizzare il pagamento, per il tramite del payment gateway;\n" +
                            "d) in caso di conferma dell’ordine da parte dell’Utente Commerciale, l’importo pre-autorizzato sarà effettivamente incassato dal Fornitore, per il tramite del payment gateway;\n" +
                            "e) in caso di rifiuto dell’ordine da parte dell’Utente Commerciale, oppure di mancata conferma dell’ordine entro il termine di 24 ore dalla notifica di ricezione dell’ordine, l’importo pre-autorizzato sarà automaticamente svincolato e restituito all’Utilizzatore finale nei termini previsti dal gestore del payment gateway."
                        }
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"3.10. Gestione dei rimborsi"}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "Le operazioni di rimborso sono interamente gestite, in forza di mandato conferito dall’Utente Commerciale al Fornitore con il Contratto, mediante apposito tool all’interno della Piattaforma, integrato con il payment gateway di terze parti a ciò abilitate (attualmente Stripe.com, https://stripe.com/it-us/legal/consumer).\n\n" +
                            "In sintesi, il procedimento è così articolato:\n" +
                            "a) A seguito dell’annullamento di un ordine da parte dell’Utilizzatore finale, la LoceM App rende disponibile mediante apposito tasto la richiesta di rimborso del prezzo versato (al netto dell’eventuale penale applicata in base alla politica di annullamento adottata dall’Utente Commerciale), se ne ricorrono i presupposti;\n" +
                            "b) Una volta trasmessa la richiesta di rimborso, il sistema informatico della Piattaforma invia al payment gateway l’ordine di rimborso sul metodo di pagamento prescelto dall’Utilizzatore finale al momento dell’invio dell’Ordine di Pagamento. In tale ipotesi l’importo sarà effettivamente accreditato all’Utilizzatore finale nei termini previsti dal gestore del payment gateway e dall’istituto bancario di appoggio dell’Utilizzatore finale;\n" +
                            "c) Nel caso in cui il payment gateway rilevi errori nel procedimento di rimborso (ad es. scadenza della carta di credito utilizzata dall’Utilizzatore finale per il pagamento del noleggio), l’Utilizzatore finale riceverà una notifica (e-mail e in-app), con l’invito a contattare il supporto tecnico del Fornitore per l’aggiornamento del metodo di rimborso."
                        }
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"3.11. Ritiro degli articoli noleggiati."}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "Il ritiro degli articoli noleggiati dovrà essere effettuato a cura dell’Utilizzatore finale presso il punto di noleggio prescelto, nel giorno e nell’ora indicati nell’Ordine di Noleggio, e previa esibizione all’Utente Commerciale della Conferma d’Ordine.\n\n" +
                            "Eventuali modifiche dell’orario di ritiro dovranno essere concordate direttamente con l’Utente Commerciale, ai contatti indicati nella Conferma d’Ordine, prima dell’orario del ritiro indicato nell’Ordine di Noleggio.\n\n" +
                            "In ogni caso, in assenza di comunicazioni da parte dell’Utilizzatore finale, l’ordine dovrà ritenersi annullato se l’articolo non viene ritirato entro il tempo massimo di 60 minuti dall’orario indicato per il ritiro. In tal caso l’Utilizzatore finale non avrà diritto al rimborso del prezzo pagato (penale pari al 100%).\n\n" +
                            "L’articolo dovrà poi essere riconsegnato nel giorno e nell’ora indicati nell’Ordine di Noleggio e in conformità con le condizioni generali applicate dal singolo Utente Commerciale.\n\n" +
                            "Con il ritiro l’Utilizzatore finale dichiara di aver verificato lo stato del mezzo e di accettarlo senza riserve.\n\n" +
                            "Con il ritiro l’Utilizzatore finale dichiara di aver verificato lo stato del bene, di accettarlo senza riserve e di assumerne la custodia ai sensi dell’art. 2051 c.c."
                        }
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"3.12. Sistema di messaggistica integrato (“Posta”)"}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "La Piattaforma è dotata di un sistema di messaggistica integrato (Posta) per il tramite della quale l’Utilizzatore finale ha la possibilità di interfacciarsi direttamente con l’Utente Commerciale (e viceversa) per eventuali comunicazioni inerenti agli Ordini di Noleggio confermati.\n\n" +
                            "Il servizio di Posta è attivabile a discrezione dell’Utente Commerciale e accessibile dall’Utente Commerciale da un’apposita sezione presente nel Sito Web.\n\n" +
                            "In particolare il servizio di Posta è attivabile dall’Utente Commerciale successivamente alla conferma di un determinato ordine e rimarrà attivo sino alle ore 23.59 dell’ultimo giorno di noleggio. Il servizio di Posta si disattiva automaticamente a partire dalle ore 0.00 del primo giorno successivo al termine del noleggio e in caso di eventuale annullamento dell’ordine.\n\n" +
                            "Il servizio di Posta deve essere utilizzato al solo scopo di ricevere e fornire informazioni in merito agli Ordini di Noleggio confermati.\n\n" +
                            "E’ pertanto vietata qualsiasi condotta volta a:\n" +
                            "a) indurre gli Utenti Privati ad annullare l’Ordine di Noleggio già confermato e/o effettuarne altri ordini mediante modalità esterne alla Piattaforma, anche verso la promessa di sconti o condizioni economiche più favorevoli;\n" +
                            "b) trasmettere o chiedere dati personali ulteriori rispetto a quanto normalmente richiesto dalla Piattaforma per la gestione degli Ordini di Noleggio;\n" +
                            "c) chiedere agli Utenti Privati o promettere agli Utenti Commerciali recensioni o commenti positivi, anche mediante canali esterni alla Piattaforma, anche verso la promessa o la richiesta di sconti o altre pratiche volte a falsare il giudizio dell’utente;\n" +
                            "d) utilizzare espressioni offensive o in qualunque modo discriminatore nei confronti degli Utenti Privati;\n" +
                            "e) utilizzare il servizio di Posta per scopi estranei alla gestione dell’Ordine di Noleggio per il quale è stato attivato.\n\n" +
                            "Al fine di garantire la sicurezza e il rispetto delle disposizioni normative e regolamentari vigenti, nonché l’osservanza dei Termini d’Uso della Piattaforma da parte degli Utenti Commerciali e degli Utenti Privati, il Fornitore si riserva la facoltà di effettuare controlli, diretti (su segnalazione dell’Utente o della Pubblica Autorità), ovvero a campione, sullo scambio di comunicazioni all’interno del servizio di Posta, nel pieno rispetto della normativa sui trattamento dei dati personali e degli obblighi di riservatezza contrattualmente assunti con l’Utente Commerciale."
                        }
                    />
                </div>

                {/* Nuova sezione 4 – completa */}
                <div style={globalPageStyle.mainSectionLegal}>
                    <MyNormalText
                        text={"4. CUSTODIA DEL BENE E RESPONSABILITÀ DELL’UTILIZZATORE FINALE"}
                        bold={true}
                        fontSize={24}
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"4.1"}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "Con il ritiro della bicicletta presso il punto di noleggio, l’Utilizzatore finale acquisisce il possesso materiale e la piena disponibilità del bene.\n\n" +
                            "A decorrere dal momento del ritiro e sino alla riconsegna, l’Utilizzatore finale assume la qualifica di custode del bene, ai sensi e per gli effetti dell’art. 2051 del Codice Civile.\n\n" +
                            "Durante tale periodo, l’Utilizzatore finale esercita sul bene un autonomo potere di fatto, di controllo, di vigilanza e di gestione."
                        }
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"4.2"}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "In qualità di custode, l’Utilizzatore finale è responsabile di ogni danno cagionato dalla bicicletta a persone, animali o cose.\n\n" +
                            "La responsabilità sussiste anche in assenza di colpa, salvo il caso fortuito.\n\n" +
                            "Resta esclusa ogni responsabilità dell’Utente Commerciale e del Fornitore per i danni verificatisi durante il periodo di custodia."
                        }
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"4.3"}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "L’Utilizzatore finale è tenuto a:\n" +
                            "a) custodire il bene con diligenza;\n" +
                            "b) impedirne l’uso da parte di terzi;\n" +
                            "c) proteggerlo da furti, smarrimenti o danneggiamenti;\n" +
                            "d) conservarlo in condizioni di sicurezza.\n\n" +
                            "È fatto espresso divieto di affidare la bicicletta a soggetti diversi dal titolare dell’Ordine."
                        }
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"4.4"}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "L’Utilizzatore finale riconosce che la custodia del bene comporta l’assunzione dei rischi connessi all’utilizzo, alla circolazione e alla conservazione dello stesso.\n\n" +
                            "Tali rischi sono integralmente assunti dall’Utilizzatore finale per tutta la durata del noleggio.\n\n" +
                            "Nessun rischio resta in capo all’Utente Commerciale o al Fornitore."
                        }
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"4.5"}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "L’Utilizzatore finale risponde della perdita, del furto, dello smarrimento e del danneggiamento del bene.\n\n" +
                            "In tali ipotesi, l’Utilizzatore finale è tenuto al risarcimento integrale del valore del bene, salvo prova del caso fortuito.\n\n" +
                            "La responsabilità permane anche in caso di sottrazione da parte di terzi."
                        }
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"4.6"}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "La custodia cessa esclusivamente con la riconsegna materiale del bene all’Utente Commerciale.\n\n" +
                            "La semplice cessazione dell’utilizzo non comporta cessazione della custodia."
                        }
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"4.7"}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "L’Utilizzatore finale manleva l’Utente Commerciale e il Fornitore da ogni conseguenza derivante dalla responsabilità di custodia.\n\n" +
                            "L’obbligo permane anche dopo la cessazione del rapporto."
                        }
                    />
                </div>

                {/* Nuova sezione 5 */}
                <div style={globalPageStyle.mainSectionLegal}>
                    <MyNormalText
                        text={"5. RESPONSABILITÀ DELL’UTILIZZATORE FINALE E MODALITÀ DI UTILIZZO DELLE BICICLETTE"}
                        bold={true}
                        fontSize={24}
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"5.1"}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "L’Utilizzatore finale dichiara, sotto la propria responsabilità, di essere fisicamente e psichicamente idoneo alla conduzione della bicicletta noleggiata e garantisce di possedere adeguata capacità tecnica e conoscenza delle regole di circolazione."
                        }
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"5.2"}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "È fatto divieto di utilizzo in condizioni di alterazione psicofisica."
                        }
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"5.3"}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "L’Utilizzatore finale si impegna a utilizzare la bicicletta:\n" +
                            "a) con la diligenza del buon padre di famiglia;\n" +
                            "b) nel rispetto del Codice della Strada;\n" +
                            "c) secondo le istruzioni ricevute."
                        }
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"5.4"}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "È vietato:\n" +
                            "a) il subnoleggio;\n" +
                            "b) la cessione a terzi;\n" +
                            "c) l’uso su percorsi vietati;\n" +
                            "d) effettuare modifiche tecniche."
                        }
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"5.5"}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "L’Utilizzatore finale riconosce che l’uso della bicicletta comporta rischi connessi alla circolazione stradale e se ne assume integralmente tali rischi."
                        }
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"5.6"}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "L’Utente Commerciale e il Fornitore sono esonerati da responsabilità per eventi derivanti da condotta imprudente, violazioni normative, uso improprio."
                        }
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"5.7"}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "L’Utilizzatore finale risponde di ogni danno arrecato alla bicicletta, a terzi, a cose, a sé stesso.\n\n" +
                            "In caso di danno, l’Utilizzatore finale è tenuto al risarcimento integrale.\n\n" +
                            "Resta salva per l’Utente Commerciale la facoltà di trattenere la cauzione."
                        }
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"5.8"}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "In caso di sinistro, l’Utilizzatore finale deve informare immediatamente l’Utente Commerciale; l’omessa comunicazione comporta responsabilità aggravata."
                        }
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"5.9"}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "L’Utilizzatore finale manleva il Fornitore e l’Utente Commerciale da ogni pretesa di terzi."
                        }
                    />
                </div>

                <div style={globalPageStyle.mainSectionLegal}>
                    <MyNormalText
                        text={"6. PROPRIETÀ INTELLETTUALE. LICENZA D’USO."}
                        bold={true}
                        fontSize={24}
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"6.1 Proprietà intellettuale."}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "La Piattaforma, il Sito Web e il relativo dominio, nonché la LoceM Business App sono di esclusiva proprietà del Fornitore, unico soggetto che può legittimamente disporne e concederne a terzi i relativi Diritti di utilizzazione economica.\n\n" +
                            "La documentazione, le immagini, i caratteri, la grafica e il layout, il software, nonché la presentazione e l’elaborazione degli stessi, il codice sorgente, gli altri codici e format scripts di implementazione, e, più in generale, tutte le altre componenti informatiche e altri contenuti della Piattaforma, del Sito Web e della LoceM Business App sono di proprietà del Fornitore, oppure sono stati a questo concessi in utilizzo dai rispettivi legittimi proprietari.\n\n" +
                            "I contenuti di cui al precedente paragrafo sono tutelati e protetti dalle disposizioni vigenti in materia di proprietà intellettuale e industriale.\n\n" +
                            "Tutti i diritti in questione (compresi, senza limitazione, diritti d’autore, brevetti, know-how, marchi e segni distintivi) appartengono al Fornitore oppure sono stati a questo concessi in utilizzo da parte dei rispettivi e legittimi proprietari.\n\n" +
                            "L’accesso alla Piattaforma e/o la licenza d’uso della LoceM Business App non forniscono all’Utente Commerciale il diritto di cedere o sublicenziare a terzi le relative credenziali per l’utilizzo e/o la licenza d’uso, né di riprodurre, di modificare, di distribuire, di ripubblicare, in alcuna forma anche parziale i suddetti contenuti, senza l’espressa autorizzazione scritta da parte del titolare dei relativi diritti di sfruttamento, fatte salve le ipotesi tassative legittimamente riconosciute ai sensi degli artt. 64bis e ss. L.d.A..\n\n" +
                            "La violazione di uno dei diritti di privativa spettanti al Fornitore o a questi concessi in utilizzo dai rispettivi legittimi titolari costituisce causa di responsabilità per l’Utente Commerciale."
                        }
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"6.2 Licenza d’uso della LoceM Business App"}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "La gestione dell’Account Business è consentita attraverso l’utilizzo della LoceM Business App, entro i limiti e nel pieno rispetto dei termini e delle condizioni di cui al precedente punto 4.1.\n\n" +
                            "La LoceM Business App è un’applicazione software di esclusiva proprietà di LoceM, compatibile con qualsiasi device Android (versioni AndroidOS 11 e successive) e IOS (versione IOS 13.7 e successive).\n\n" +
                            "La LoceM Business App è fornita all’Utente Commerciale in licenza d’uso, non esclusiva, secondo le condizioni e per tutto il periodo di vigenza del Contratto.\n\n" +
                            "Per qualsiasi ipotesi di perdita di efficacia del Contratto di cui al precedente punto 3.3, l’utilizzo della LoceM Business App sarà consentito sino ai 90 giorni successivi alla data di scioglimento del Contratto, onde consentire l’evasione degli ordini pendenti.\n\n" +
                            "Decorso il termine suddetto la licenza d’uso sarà revocata."
                        }
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"6.3 Applicazioni e siti web di terze parti."}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "All’interno della Piattaforma potrebbero essere presenti tool di interazione con applicazioni di terze parti, oppure link a siti web gestiti da soggetti diversi dal Fornitore.\n\n" +
                            "I presenti Termini d’Uso non si applicano all’utilizzo delle applicazioni o siti web di terzi a cui si potrebbe accedere tramite la Piattaforma.\n\n" +
                            "L'utilizzo di qualsiasi applicazione o sito web di terze parti potrebbe essere soggetto a termini e condizioni aggiuntivi.\n\n" +
                            "Il Fornitore non opera alcun controllo in merito alle informazioni, ai prodotti, ai servizi eventualmente offerti o alle politiche privacy e cookie adottate da tali applicazioni o siti web di terze parti.\n\n" +
                            "L’Utente Commerciale è quindi invitato a prendere autonomamente visione delle policy e dei termini d’uso delle suddette applicazioni e siti web di terze parti.\n\n" +
                            "In ogni caso a fronte di eventuali comunicazioni da parte degli Utenti Commerciali sul malfunzionamento o non affidabilità di tali applicazioni e siti web di terze parti, il Fornitore potrà, a proprio insindacabile giudizio, valutare di sospenderne il collegamento."
                        }
                    />
                </div>

                <div style={globalPageStyle.mainSectionLegal}>
                    <MyNormalText
                        text={"7. LIMITAZIONE, SOSPENSIONE E CESSAZIONE SERVIZI (in conformità con art. 4 Reg. UE 1150/2019)"}
                        bold={true}
                        fontSize={24}
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"7.1"}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "Il Fornitore si riserva la facoltà di sospendere o limitare la fornitura dei servizi della Piattaforma all’Utente Commerciale, a causa di determinate condotte da parte di quest’ultimo con riferimento alle modalità di utilizzo della Piattaforma, ovvero dei prodotti/servizi offerti dall’Utente Commerciale, oppure in caso di provvedimenti legislativi, regolamentari od ordini della Pubblica Autorità."
                        }
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"7.2"}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "Salvo che il fatto costituisca causa di risoluzione di diritto del Contratto, oppure in caso di adempimento di un obbligo normativo, regolamentare od ordine della Pubblica Autorità, il Fornitore si riserva, altresì, la facoltà di cessare completamente la fornitura dei servizi della Piattaforma all’Utente Commerciale, a causa di determinate condotte da parte di quest’ultimo con riferimento alle modalità di utilizzo della Piattaforma, ovvero dei prodotti/servizi offerti dall’Utente Commerciale.\n\n" +
                            "La suddetta prerogativa riservata al Fornitore costituisce un diritto di recesso unilaterale dal Contratto in favore di quest’ultimo."
                        }
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"7.3"}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "La decisione di adottare una delle misure di cui ai precedenti punti 7.1 e 7.2 sarà preceduta dalla notifica mediante PEC di un preavviso all’Utente Commerciale, almeno 30 giorni prima della data di sospensione/limitazione/cessazione.\n\n" +
                            "Nel preavviso saranno indicate dal Fornitore le motivazioni della decisione adottata, con l’invito a fornire eventuali controdeduzioni (all’indirizzo PEC locemsolutions@pro-pec.it) entro e non oltre il termine di 15 giorni dalla notifica del preavviso.\n\n" +
                            "Nei 15 giorni successivi alla ricezione delle controdeduzioni sarà notificata all’Utente Commerciale la decisione sulle controdeduzioni. In caso di rigetto delle controdeduzioni sarà adottata la misura preannunciata nel preavviso."
                        }
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"7.4"}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "Il termine di cui al precedente punto 7.3 non si applica nel caso in cui:\n" +
                            "a) Il Fornitore è tenuto ad adempiere a un obbligo normativo, regolamentare od ordine della Pubblica Autorità che gli impone di cessare la fornitura dell'insieme dei suoi servizi di intermediazione online a un determinato Utente Commerciale in un modo che non gli consente di rispettare il termine di preavviso, oppure\n" +
                            "b) Il Fornitore esercita un diritto di recesso fondato su motivi imperativi a norma del diritto italiano in conformità con il diritto dell’Unione Europea;\n" +
                            "c) L’Utente Commerciale ha ripetutamente violato i presenti Termini d’Uso, oppure è incorso in una causa di risoluzione di diritto del Contratto."
                        }
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"7.5"}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "Salva l’ipotesi in cui la causa di limitazione/sospensione/cessazione risieda in divieti di legge, regolamenti od ordini da parte della Pubblica Autorità di prosecuzione dell’attività imprenditoriale da parte dell’Utente Commerciale ovvero di commercializzazione di determinati beni o prodotti, gli eventuali ordini pendenti (già confermati), la cui esecuzione è successiva rispetto alla data di applicazione della limitazione/sospensione/cessazione, saranno comunque evasi dall’Utente Commerciale e visibili all’interno della Piattaforma."
                        }
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"7.6"}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "In caso di cessazione ai sensi del precedente punto 7.2 si applica il precedente punto 3.3 (Disattivazione Account. Cancellazione)."
                        }
                    />
                </div>

                <div style={globalPageStyle.mainSectionLegal}>
                    <MyNormalText
                        text={"8. GARANZIE. MANUTENZIONE. AGGIORNAMENTO. SUPPORTO TECNICO."}
                        bold={true}
                        fontSize={24}
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"8.1"}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "Il Fornitore garantisce esclusivamente che la Piattaforma e la LoceM Business App sono in grado di eseguire le operazioni previste e indicate nelle descrizioni tecniche riportate nella Scheda Tecnica allegata al Contratto."
                        }
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"8.2"}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "La garanzia di cui al precedente punto 8.1 è, peraltro, condizionata al corretto funzionamento dei devices e dei relativi software di sistema utilizzati dall’Utente Commerciale ed al corretto uso degli stessi da parte dell’Utente Commerciale."
                        }
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"8.3"}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "Il Fornitore ha adottato e costantemente adotta tutte le misure e i presidi idonei al mantenimento in sicurezza della Piattaforma e degli Account dei propri iscritti, nei limiti dell’ordinaria diligenza."
                        }
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"8.4"}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "Per qualsiasi segnalazione, richiesta di informazioni o supporto tecnico in relazione a condotte di Utenti Privati o altri Utenti Commerciali, modalità o problemi tecnici di funzionamento della Piattaforma, l’Utente Commerciale è invitato a inviare una richiesta di supporto secondo le seguenti modalità:\n\n" +
                            "a) tramite l’apposita sezione presente all’interno della Piattaforma (Sito Web e/o LoceM Business App), ovvero\n" +
                            "b) inviando una e-mail all’indirizzo help@locemsolutions.com\n" +
                            "c) contattando il Fornitore agli eventuali ulteriori recapiti da questi indicati.\n\n" +
                            "La richiesta di supporto sarà presa in carico entro 24 ore dalla ricezione da parte del Fornitore ed evasa nel più breve tempo possibile, anche in ragione della natura e dell’urgenza dell’intervento richiesto."
                        }
                    />
                </div>

                <div style={globalPageStyle.mainSectionLegal}>
                    <MyNormalText
                        text={"9. ESONERO RESPONSABILITÀ’"}
                        bold={true}
                        fontSize={24}
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"9.1"}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "Il Fornitore declina ogni responsabilità in relazione a:\n\n" +
                            "a) adempimento delle obbligazioni assunte dall’Utente Commerciale nei confronti dell’Utilizzatore finale in virtù del contratto di noleggio stipulato con quest’ultimo per il tramite della Piattaforma;\n" +
                            "b) sicurezza e conformità dei beni e delle attrezzature offerte in noleggio;\n" +
                            "c) contestazioni da parte della Pubblica Autorità in relazione alla messa a noleggio di beni e attrezzature non sicure o non conformi;\n" +
                            "d) danni o pregiudizi arrecati a Utenti Privati o a terzi dall’Utente Commerciale, e/o dai beni e dalle attrezzature da questi concessi in noleggio;\n" +
                            "e) inadempimenti contrattuali, condotte lesive o abusive, danni provocati all’Utente Commerciale o a terzi, da parte degli Utenti Privati, durante l’esecuzione del contratto di noleggio;\n" +
                            "f) malfunzionamenti dei tool di interazione con applicazioni di terze parti integrate con il sistema informatico della Piattaforma (es. navigazione GPS), ovvero danni o pregiudizi subiti dall’utilizzo di tool di interazione con applicazioni di terze parti o degli eventuali link a siti web di terze parti;\n" +
                            "g) malfunzionamenti del payment gateway e tempistiche di rimborso applicate dagli istituti di credito sui quali poggiano i metodi di pagamento utilizzati dagli Utenti Privati."
                        }
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"9.2"}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "Il Fornitore declina ogni responsabilità in relazione alle informazioni e alla documentazione pubblicata dall’Utente Commerciale e/o fornita dall’Utente Commerciale al Fornitore per la pubblicazione nella Vetrina Digitale e per qualsiasi ulteriore danno o pregiudizio derivante a terzi dalla pubblicazione delle suddette informazioni / documentazione."
                        }
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"9.3"}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "Il Fornitore declina ogni responsabilità in ordine al contenuto, ai dati, alle informazioni e alle espressioni, nonché alle condotte fraudolente o scorrette in qualsiasi forma veicolate dall’Utente Commerciale verso l’Utilizzatore finale, e viceversa, anche mediante il servizio di Posta."
                        }
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"9.4"}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "Il Fornitore declina ogni responsabilità per qualsiasi danno o pregiudizio derivante dall’utilizzo della Piattaforma tramite il Sito Web o della LoceM Business App, non imputabile a dolo o colpa grave del Fornitore medesimo, a titolo esemplificativo e non esaustivo:\n\n" +
                            "a) incompatibilità della LoceM Business App e/o del Sito Web con i devices utilizzati dall’Utente Commerciale;\n" +
                            "b) danni o malfunzionamenti ai devices/softwares utilizzati dall’Utente Commerciale per l’accesso alla Piattaforma;\n" +
                            "c) problemi tecnici o malfunzionamenti in genere, imprevisti o non prevedibili con l’ordinaria diligenza, della LoceM Business App e/o del Sito Web;\n" +
                            "d) attacchi subiti dall’Utente durante l’utilizzo della LoceM Business App e/o del Sito Web (a titolo esemplificativo virus, malware, attacchi hacker, ecc.)."
                        }
                    />
                    <br/>
                    <br/>

                    <MyNormalText
                        text={"9.5"}
                        bold={true}
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={
                            "L’Utilizzatore finale riconosce espressamente che il Fornitore opera quale mero intermediario tecnico e che ogni rapporto di noleggio intercorre esclusivamente con l’Utente Commerciale.\n\n" +
                            "In considerazione della qualifica dell’Utilizzatore finale quale custode del bene, il Fornitore e l’Utente Commerciale declinano ogni responsabilità per i danni verificatisi durante il periodo di noleggio.\n\n" +
                            "Resta in ogni caso esclusa ogni responsabilità solidale o concorrente del Fornitore."
                        }
                    />
                </div>

                <div style={globalPageStyle.mainSectionLegal}>
                    <MyNormalText
                        text={"10. REGOLE POSIZIONAMENTO"}
                        bold={true}
                        fontSize={24}
                    />
                    <br/>
                    <br/>
                    <MyNormalText
                        text={
                            "Ai sensi dell’art. 5 Reg. 1150/2019, il Fornitore dichiara che il posizionamento dei risultati delle ricerche all’interno della Piattaforma avviene secondo il seguente ordine di parametri:\n\n" +
                            "a) durante la fase iniziale, sino alla raccolta di almeno 10 adesioni alla Piattaforma: ordine temporale di adesione alla Piattaforma da parte degli Utenti Commerciali;\n\n" +
                            "b) una volta raggiunta la soglia minima di adesioni di cui alla precedente lettera a), il posizionamento all’interno della Piattaforma avverrà secondo i seguenti parametri:\n" +
                            "- posizione geografica da cui accede l’Utilizzatore finale;\n" +
                            "- valutazione resa dall’Utilizzatore finale al termine di un noleggio.\n\n" +
                            "Il Fornitore si riserva la facoltà di inserire meccanismi volti ad influire sul posizionamento di cui al precedente punto 10.1, verso il pagamento di un corrispettivo da parte dell’Utente Commerciale.\n\n" +
                            "Nell’ipotesi di cui al precedente punto 10.2, il punto di noleggio dell’Utente Commerciale sarà inserito, per il periodo di tempo contrattualmente stabilito, tra i primi risultati della lista. In questo caso, il risultato della ricerca sarà contrassegnato dalla dicitura “sponsorizzato”."
                        }
                    />
                </div>

                <div style={globalPageStyle.mainSectionLegal}>
                    <MyNormalText
                        text={"11. ACCESSO AI DATI"}
                        bold={true}
                        fontSize={24}
                    />
                    <br/>
                    <br/>
                    <MyNormalText
                        text={
                            "Ai sensi dell’art. 9 Reg. 1150/2019, il Fornitore dichiara quanto di seguito.\n\n" +
                            "Il Fornitore ha la possibilità di accedere ai dati (personali e non) forniti dagli Utenti Commerciali e dagli Utenti Privati nell’ambito di utilizzo della Piattaforma e, nello specifico, ha accesso a tutti i dati richiesti dalla Piattaforma per la corretta erogazione dei relativi servizi.\n\n" +
                            "Con riferimento ai dati presenti nel servizio di Posta, si rinvia all’informativa privacy, secondo la quale la verifica da parte del Fornitore è consentita al fine di verificare un uso illecito della Piattaforma e il corretto adempimento dei Termini d’Uso del Servizio.\n\n" +
                            "L’Utente Commerciale ha accesso ai soli dati (personali e non) forniti dall’Utilizzatore finale mediante l’invio dell’Ordine di Noleggio, ovvero mediante il servizio di Posta e, nello specifico ha accesso a tutti i dati richiesti dalla Piattaforma per il perfezionamento e la corretta esecuzione del contratto di noleggio.\n\n" +
                            "L’Utente Commerciale ha la possibilità di accedere, previa richiesta al Fornitore, ai soli dati statistici in forma aggregata e anonima relativi all’andamento dei propri noleggi su base periodica (annuale).\n\n" +
                            "Il Fornitore si riserva di fornire a terzi i soli dati di cui al precedente punto 9.4, sempre in forma aggregata ed anonima, in tal caso anche con riferimento alle generalità degli Utenti Commerciali da cui sono stati ricavati e sempre limitatamente alle sole finalità statistiche."
                        }
                    />
                </div>

                {/* Footer di chiusura (opzionale – puoi rimuoverlo o modificarlo) */}
                <div style={globalPageStyle.mainSectionLegal}>
                    <br/>
                    <br/>
                    <MyNormalText
                        text={
                            "Questi Termini d’Uso costituiscono un accordo vincolante tra il Fornitore e l’Utente Commerciale / Utilizzatore finale. Continuando a utilizzare la Piattaforma e/o la LoceM App dopo la data di entrata in vigore indicata, si accetta integralmente quanto sopra."
                        }
                        fontSize={18}
                    />
                    <br/>
                    <MyNormalText
                        text={"Ultimo aggiornamento: 27 febbraio 2026"}
                        fontSize={16}
                    />
                </div>

            </main>
        </div>
    );
}

export default LocemTermsOfService;
